/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import React from 'react';
import {HeaderItem, sendGaEvent} from '@dvrd/dvr-controls';
import Header from "./header";
import {pageScroller} from "../../util/utils";
import {useNavigate} from 'react-router';
import {afterNavigate} from "../../util/navigationUtil";

export default function HeaderController() {
    const navigate = useNavigate();

    function onClickItem(item: HeaderItem) {
        return function () {
            sendGaEvent('click', 'header', item.label);
            afterNavigate(item.route, true, item.id, pageScroller, navigate);
        }
    }

    function onClickLogo() {
        sendGaEvent('click', 'header', 'logo');
        afterNavigate('/', true, undefined, pageScroller, navigate);
    }

    return (
        <Header onClickLogo={onClickLogo} onClickItem={onClickItem}/>
    )
}